import ScrollToTopButton from "../components/ScrollToTopButton";
import WorkorderCards from "../components/WorkorderCards";

export default function FollowingPage() {
  return (
    <>
      <div className="border-b text-5xl mt-5 mb-6 p-4">
        <div className="ml-5 font-skyBold">Following</div>
      </div>

      <div className="mt-8 ">
        <ScrollToTopButton></ScrollToTopButton>

        <WorkorderCards contextPage="follow"></WorkorderCards>
      </div>
    </>
  );
}
